export interface Badge {
    /**
     * @description : This represents the `name` of the `Badge`
     */
    name: string;
}
